module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_front_bg_simple-e0c70661c34c81e16eb391872c4ab2fd.png";